import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/quotation-mark.png'


const _withScopeId = n => (_pushScopeId("data-v-115dbefa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "top-title" }, "TESTIMONIALS"),
  /*#__PURE__*/_createElementVNode("h2", { title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" }, "We help to achieve customers business goals")
], -1))
const _hoisted_4 = { class: "border-style pb-75" }
const _hoisted_5 = { class: "testimonial-wrapper" }
const _hoisted_6 = { class: "row align-items-center" }
const _hoisted_7 = { class: "col-lg-3" }
const _hoisted_8 = { class: "testimonial-info" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "degeneration" }
const _hoisted_11 = { class: "col-lg-9" }
const _hoisted_12 = { class: "for-before-after" }
const _hoisted_13 = { class: "testimonials-single-item-two" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore",
  src: _imports_0,
  alt: "quotation-mark"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-controller testimonials-controller" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "controller-icon prev" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-left-line" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "controller-icon next" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-right-line" })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_swiper, {
          spaceBetween: 25,
          slidesPerView: 1,
          preventClicks: true,
          loop: true,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          navigation: {
            nextEl: '.next',
            prevEl: '.prev',
          },
          modules: _ctx.modules,
          class: "testimonial-slide"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testimonials, (testimonial) => {
              return (_openBlock(), _createBlock(_component_swiper_slide, {
                key: testimonial.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("img", {
                            title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore",
                            src: testimonial.image,
                            alt: "testimonials"
                          }, null, 8, _hoisted_9),
                          _createElementVNode("h3", null, _toDisplayString(testimonial.name), 1),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(testimonial.designation), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createElementVNode("p", null, _toDisplayString(testimonial.description), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _hoisted_15
          ]),
          _: 1
        }, 8, ["modules"])
      ])
    ])
  ]))
}